import { IconBase } from "@Components/Icons/IconBase";
import * as css from "@Components/Icons/IconBase.module.css";

export class Stop extends IconBase {
    protected cssClassName: string = "Stop";

    protected get icon(): JSX.Element {
        return (
            <svg viewBox="0 0 424 424">
                <rect x="141.73" y="140" width="26" height="122" rx="13" ry="13" />
                <rect x="173.4" y="105" width="26" height="111" rx="13" ry="13" />
                <rect x="205.06" y="91" width="26" height="120" rx="13" ry="13" />
                <rect x="236.73" y="103" width="26" height="113" rx="13" ry="13" />
                <path d="M270.86,267.1h0a13,13,0,0,1-9.34-15.84L275,199c1.79-6.92,7.23-24.69,32.06-24.69,0,0-1.67,8.5-5.67,23.33l-14.7,60.09A13,13,0,0,1,270.86,267.1Z" />
                <path d="M287.24,255.54c-9.57,40.3-30.79,71.76-72.21,71.76a75,75,0,0,1,0-150c18.29,0,47.7-1.09,47.7,15.87,0,20.33-.29,37.55,1.3,39.13,3.09,3.09,11.09-12.13,14-25.39C281.29,192.4,293.41,229.58,287.24,255.54Z" />
                <circle className={css.circleStroke} cx="212" cy="212" r="205" />
            </svg>
        );
    }
}
